import { useLazyChangeTransactionStateQuery } from "@/modules/transaction/services";
import { OperationNextState } from "@/shared/common/enums";
import { useAppSelector, useNotify } from "@/shared/hooks";
import { Modal } from "@ab.uitools/ui-library/components/Modal";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useTranslation } from "react-i18next";

interface Props {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
}

export const SendToEditModal = ({
  isOpen,
  onClose,
  onConfirm,
}: Props) => {
  const { t } = useTranslation();
  const { showSuccessSnackbar, showErrorSnackbar } = useNotify();
  const transaction = useAppSelector((state) => state.transactions.transaction);
  const [sendToEdit] = useLazyChangeTransactionStateQuery();

  const handleSendToEdit = () => {
    if (transaction?.id) {
      sendToEdit({
        id: transaction.id,
        data: {
          transactionType: transaction.transactionType,
          nextState: OperationNextState.SendToEdit,
        },
      })
        .unwrap()
        .then(() => {
          showSuccessSnackbar(t("alerts.transferHasBeenSuccessfullySendToEdit"));
          onConfirm();
          onClose();
        })
        .catch((error) => {
          showErrorSnackbar(error);
          onClose();
        });
    }
  };

  return (
    <Modal
      onSubmit={handleSendToEdit}
      titleProps={{
        title: t("transfer.sendToEdit.title"),
        size: "large",
      }}
      isOpen={isOpen}
      onClose={onClose}
      buttonProps={{
        confirm: {
          buttonText: t("general.confirm"),
          buttonActionType: "submit",
        },
        cancel: {
          buttonText: t("general.cancel")
        },
      }}
    >
      <div>
        <Text>{t("transfer.sendToEdit.description")}</Text>
      </div>
    </Modal>
  );
};
